import Vue from 'vue'
import App from './App'
import VueResource from 'vue-resource'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueProgressBar from 'vue-progressbar'

Vue.use(VueResource)
axios.defaults.headers.common['X-CMS-Request'] = 'forms'
Vue.use(VueAxios, axios)
Vue.use(VueProgressBar, {
  color: '#1E90FF',
  failedColor: '#D91E18',
  height: '3px'
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#form-render',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js